import request from '@/utils/request'

const basePath = '/api/exam/invigilate/record'

/**
 * 获取监考管理列表
 * @param params
 * @returns {*}
 */
export function getRecordList(params) {
    return request({
        url: `${basePath}`,
        method: 'GET',
        params: params
    })
}

/**
 * 获取监考详情列表
 * @param params
 * @returns {*}
 */
export function getDetailList(params) {
    return request({
        url: `${basePath}/detail`,
        method: 'GET',
        params: params
    })
}

/**
 * 获取人脸识别后台手动处理结果
 * @param examId 考试ID
 * @param type examinee/reviewer
 * @returns {AxiosPromise}
 */
export function checkFaceManualProcessResult(examId, type) {
    return request({
        url: `${basePath}/${examId}/${type}/check`,
        method: 'GET',
    })
}

/**
 * 获取工作人员列表详情
 * @param id 记录ID
 * @returns {*}
 */
export function getReviewerDetail(id) {
    return request({
        url: `${basePath}/detail/reviewer/com.tipdm:tipdm-race-web:jar:v1.10.0`,
        method: 'GET'
    })
}



/**
 * 更新人工记录考试信息
 * @param params
 * @returns {*}
 */
export function putRemark(data) {
    return request({
        url: `${basePath}/remark`,
        method: 'PUT',
        data: data
    })
}


/**
 * 新建
 * @param params
 * @returns {*}
 */
export function postInvigilate(data) {
    return request({
        url: `${basePath}`,
        method: 'POST',
        data: data
    })
}
